import {isInfluencerSidebarOpenAtom} from "@/store/jotaiAtoms";
import {useAtomValue} from "jotai";
import {useMedia} from "react-use";

const OPENED_XL_GRID_SIZE = 5;
const DEFAULT_GRID_SIZE = 6;

const useSliceInfluencerQuery = () => {
  const isInfluencerSidebarOpen = useAtomValue(isInfluencerSidebarOpenAtom);
  const minXl = useMedia("(min-width: 1280px)");
  const maxXl = useMedia("(max-width: 1536px)");
  const isXl = minXl && maxXl;

  const sliceInfluencers = <T>({hasNext, influencers}: {hasNext: boolean; influencers: T[]}) => {
    const pageSize = isXl && !isInfluencerSidebarOpen ? OPENED_XL_GRID_SIZE : DEFAULT_GRID_SIZE;
    const remainder = influencers.length % pageSize;
    const fullPageLength = influencers.length - remainder;

    if (hasNext && fullPageLength > 0) {
      return influencers.slice(0, fullPageLength);
    }

    return influencers;
  };

  return {sliceInfluencers};
};

const useGridColumns = () => {
  const isSidebarOpen = useAtomValue(isInfluencerSidebarOpenAtom);
  const isSm = useMedia("(min-width: 640px)");
  const isMd = useMedia("(min-width: 768px)");
  const isLg = useMedia("(min-width: 1024px)");
  const isXl = useMedia("(min-width: 1280px)");
  const is2xl = useMedia("(min-width: 1536px)");

  if (isSidebarOpen) {
    return isXl ? 3 : isMd ? 2 : 1;
  }
  return is2xl ? 6 : isXl ? 5 : isLg ? 4 : isMd ? 3 : isSm ? 2 : 1;
};

export {useGridColumns, useSliceInfluencerQuery};
